import { getTaskObservations } from '../../api/api';
import { Task } from '../../api/queries/workOrders';
import { AssetObservationsState, createAssetObservationsSlice } from './abstract/asset';

const taskObservationsSlice = createAssetObservationsSlice<Task>('tasks', {
  fetchObservations: getTaskObservations,
});

const { fetchAssetObservations } = taskObservationsSlice.actions;
export { fetchAssetObservations as fetchTaskObservations };

export const { selectState: selectTaskObservationsState } = taskObservationsSlice.getSelectors(
  (state: { observations: { tasks: AssetObservationsState<Task> } }) => state.observations.tasks,
);

export default taskObservationsSlice.reducer;
